import {Pipe, PipeTransform} from '@angular/core';
import {PermissionService} from '@shared/service/permission.service';
import {NemoModuleKeys, UserPermissionsModel} from '@shared/models/user-permission.model';
import {TranslatePipeService} from '@shared/service/translate-pipe.service';
import {Location} from '@angular/common';
import {CLAIMS_PUBLIC_PROFILES, PROFILE_CLAIMS_MYALD_KEY, PROFILE_PUBLIC_USER_KEY} from '../../permissions-variables';

@Pipe({
	name: 'translateSelect'
})
export class TranslatePipe implements PipeTransform {

	constructor(private permissionService: PermissionService,
				private translatePipeService: TranslatePipeService,
				private location: Location) {
	}

	transform(key: string, context?: TranslateContext, suffix?: string, canChangeByUserProfileType?: boolean): string {
		const module: string = context || this.location.path().split('/')[1];
		if (module) {
			const messages: { [key: string]: string } = this.translatePipeService.getMessages(module) || {};
			const userType: string = canChangeByUserProfileType && this.permissionService.profileType;
			if (!suffix) {
				return (userType && messages && messages[`${key}_${userType}`]) || (messages && messages[key]) || key;
			}
			return (userType && messages && messages[`${key}_${suffix}_${userType}`]) || (messages && messages[`${key}_${suffix}`]) || key;
		}
		return key;
	}
}

export enum TranslateContext {
	ADMINISTRATION = 'administration',
	AUTHORITY = 'authority',
	CLAIMS = 'claims',
	CONTRACT_CLOSING = 'contract-closing',
	AUTHORITY_ACCEPTANCE = 'authority-acceptance-modal',
	BREADCRUMBS_TITLES = 'breadcrumbs/titles/titles',
	BREADCRUMBS_LINK_ITEMS = 'breadcrumbs/link_items/link_items',
	HEADER = 'header/header',
	AUTHORITY_FORM = 'authority-form',
	FLOTTA_POOL = 'flotta-pool/flotta-pool',
	NOTIFICATION_CENTER = 'notification-center',
	BOOKINGS = 'bookings',
	DELIVERY = 'delivery',
	BOOKING_CALENDAR = 'booking-calendar',
	LOGISTICS = 'logistics',
	INVOICING = 'invoicing',
	PROFILE = 'profile',
	DIGITAL_SIGN = 'digital-sign',
	USER_CHANGE = 'user-change',
	SHARED = 'shared',
	TYRES = 'tyres',
	CORE = 'core',
	CARGOS = 'cargos'
}

